import { getDoc, doc, setDoc } from 'firebase/firestore'
import { useContext, useState } from 'react'

import { FirebaseContext } from '../../../Contexts'
import { Candidate } from '../../../types'

export const useRegisterCandidate = () => {
  const { candidateCollection } = useContext(FirebaseContext)
  const [response, setResponse] = useState<Candidate>()
  const registerCandidate = async (data: Candidate) => {
    const document = doc(candidateCollection, data.id)
    await setDoc(document, data)

    setResponse((await getDoc(document)).data())
  }

  return [response, registerCandidate] as const
}
